import PropTypes from 'prop-types'
import React from 'react'
import { ContentList } from 'Blocks'
import config from 'Config'
import { PAGE_CONTEXT as p } from 'Constants'

const RelatedTrendsList = props => {
  return (
    <div className="related">
      <ContentList
        pageName={p.INSTALOOK}
        contents={props.instalooks}
        linkLabel={config.instalooks.instalook.showMore}
        withButtonIcon={config.instalooks.instalook.withBtnIcon}
        withIntro={config.instalooks.instalook.withIntro}
        intro={config.instalooks.instalook.intro}
        title={config.instalooks.instalook.title}
        limit={config.instalooks.instalook.limit}
        variant={'homeInstalooks'}
      />
    </div>
  )
}

RelatedTrendsList.propTypes = {
  instalooks: PropTypes.any
}

export default RelatedTrendsList
